/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import 'core-js';
import "regenerator-runtime/runtime";
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import config from './config';
import Home from './Home';
import Navbar from './Navbar';
import Footer from './Footer';
import Profile from './Profile';
import Result from './Result';
import Settings from './Settings';
import OrganizationChart from './OrganizationChart';

class App extends Component {
  constructor(props) {
    super(props);
    this.oktaAuth = new OktaAuth({
      issuer: config.env.oidc.issuer,
      clientId: config.env.oidc.clientId,
      redirectUri: config.env.oidc.redirectUri,
      scopes: config.env.oidc.scopes
    });
    this.state = {
      isAuthenticated: false
    }
    this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
      props.history.replace(toRelativeUrl('/', window.location.origin));
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    console.log(this.props)
    if (prevProps?.authState && this.props?.authState && prevProps.authState.isAuthenticated !== this.props.authState.isAuthenticated) {
      this.setState({ isAuthenticated: this.props.authState?.isAuthenticated });
    }
  }

  render() {
    return (
      <Security oktaAuth={this.oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
        <div>
          <Navbar />
          <Route path="/implicit/callback" component={LoginCallback} />
          <SecureRoute path="/" exact component={Home} />
          <SecureRoute path="/profile" component={Profile} />
          <SecureRoute path="/myprofile" component={Profile} />
          <SecureRoute path="/orgchart" component={OrganizationChart} />
          <SecureRoute path="/result" component={Result} />
          <SecureRoute path="/settings" component={Settings} />
          <Footer />
        </div>
      </Security>
    );
  }
}

const AppWithRouterAccess = withRouter(App);
export default class extends Component {
  render() {
    return (<Router><AppWithRouterAccess /></Router>);
  }
}
